import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { publishingDate } from "../CareersFucConfig";
import { useNavigate } from "react-router-dom";
import "../../../../i18n/i18n";
import { useTranslation } from "react-i18next";

const SimilarJobs = (props: any) => {
    const {similarJobList} = props;
    const navigate = useNavigate();
    const [homeUrl, setHomeUrl] = useState(window.location?.origin);
    const questionId = useSelector((stete: any) => { return stete?.careers?.getQuestionId; });

    const cliendConfig = useSelector((state: any) => state.careers.cliendConfig);
    const languageSettings = cliendConfig?.data?.data?.clientSettings?.languageSettings;
    const jobViewLangLabels = languageSettings?.jobView?.[0];
     const { t } = useTranslation();
    
    const locationDetails = (job : any) => {
        return (
            <div>
                <span className="svgICon">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M8.818 9.1475C9.82423 9.1475 10.6475 8.32423 10.6475 7.318C10.6475 6.31178 9.82423 5.4885 8.818 5.4885C7.81178 5.4885 6.9885 6.31178 6.9885 7.318C6.9885 8.32423 7.81178 9.1475 8.818 9.1475ZM8.818 0C12.66 0 16.136 2.9455 16.136 7.50095C16.136 10.4099 13.8949 13.831 9.42174 17.7736C9.07413 18.0755 8.55272 18.0755 8.20512 17.7736C3.74114 13.831 1.5 10.4099 1.5 7.50095C1.5 2.9455 4.97605 0 8.818 0Z" fill="#3A3E54"/>
                </svg>
                </span>
                <strong>{t("Location")}:</strong>
                {job?.location}
            </div>
        );
    };

    const employmentType = (job : any) => {
        return (
            <div>
                <span className="svgICon">
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path  d="M9.974 3.23757H12.6576L12.6579 3.23763C13.358 3.23763 13.9265 3.80672 13.9265 4.50626V6.16906C13.9265 6.38781 13.7516 6.56269 13.5329 6.56269H7.80146V6.25621C7.80146 6.11037 7.68468 5.99359 7.53885 5.99359H6.45991C6.31408 5.99359 6.1973 6.11037 6.1973 6.25621V6.56269H0.465899C0.247149 6.56269 0.0722656 6.38781 0.0722656 6.16906V4.49197C0.0722656 3.80609 0.626549 3.23757 1.32667 3.23757H4.02458V2.56651C4.02458 1.5315 4.86989 0.685547 5.90554 0.685547H8.09304C9.12805 0.685547 9.974 1.53086 9.974 2.56651V3.23757ZM5.90536 2.08571C5.64275 2.08571 5.424 2.30446 5.424 2.56707L5.42394 3.23757L8.57423 3.23814V2.56707C8.57423 2.30446 8.35548 2.08571 8.09287 2.08571H5.90536ZM7.78635 7.29188H12.9783L12.9783 7.2918C13.1971 7.2918 13.372 7.46668 13.372 7.68543V11.4481C13.372 12.1482 12.8035 12.7167 12.1033 12.7167H1.88072C1.19483 12.7167 0.626315 12.1624 0.626315 11.4623V7.68552C0.626315 7.46677 0.801198 7.29188 1.01995 7.29188H6.22605C6.26992 7.6707 6.59064 7.97718 6.99909 7.97718C7.40695 7.97718 7.74249 7.68552 7.78635 7.29188Z" fill="#3A3E54"/>
                    </svg>
                </span>    
                <strong>{t("Employment Type")}:</strong>
                {job?.jobType}
            </div>
        );
    };

    const jobPostedDate = (job : any) => {
        return (
            <div>
                <span className="svgICon">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><mask id="mask0_7398_35126" className="mask-style" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="18"><path fillRule="evenodd" clipRule="evenodd" d="M14.7275 1.63636H15.5456C16.4456 1.63636 17.182 2.37273 17.182 3.27273V16.3636C17.182 17.2636 16.4456 18 15.5456 18H2.45472C1.55472 18 0.818359 17.2636 0.818359 16.3636V3.27273C0.818359 2.37273 1.55472 1.63636 2.45472 1.63636H3.2729V0.818182C3.2729 0.368182 3.64109 0 4.09109 0C4.54109 0 4.90927 0.368182 4.90927 0.818182V1.63636H13.0911V0.818182C13.0911 0.368182 13.4593 0 13.9093 0C14.3593 0 14.7275 0.368182 14.7275 0.818182V1.63636ZM3.2729 16.3636H14.7275C15.1775 16.3636 15.5456 15.9955 15.5456 15.5455V5.72727H2.45472V15.5455C2.45472 15.9955 2.8229 16.3636 3.2729 16.3636Z" fill="white"></path></mask><g mask="url(#mask0_7398_35126)"><rect width="18" height="18" fill="#3A3E54"></rect></g></svg>
                </span>    
                <strong>{jobViewLangLabels?.posted}:</strong>
                {publishingDate(job?.postedAt)}
            </div>
        );
    };

    const salary = (job:any) => {
        return (
            <div>
                <span className="svgICon">
                    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M10.7432 0.672852V3.26562H9.37207V0.672852H10.7432ZM10.5762 15.0254V17.3896H9.20508V15.0254H10.5762ZM11.543 12.1426C11.543 11.8086 11.4814 11.5244 11.3584 11.29C11.2412 11.0557 11.0479 10.8477 10.7783 10.666C10.5146 10.4844 10.1572 10.3086 9.70605 10.1387C8.94434 9.8457 8.27344 9.53516 7.69336 9.20703C7.11914 8.87305 6.6709 8.45996 6.34863 7.96777C6.02637 7.46973 5.86523 6.83984 5.86523 6.07812C5.86523 5.35156 6.03809 4.72168 6.38379 4.18848C6.72949 3.65527 7.20703 3.24512 7.81641 2.95801C8.43164 2.66504 9.14648 2.51855 9.96094 2.51855C10.582 2.51855 11.1445 2.6123 11.6484 2.7998C12.1523 2.98145 12.5859 3.25098 12.9492 3.6084C13.3125 3.95996 13.5908 4.39062 13.7842 4.90039C13.9775 5.41016 14.0742 5.99316 14.0742 6.64941H11.5518C11.5518 6.29785 11.5137 5.9873 11.4375 5.71777C11.3613 5.44824 11.25 5.22266 11.1035 5.04102C10.9629 4.85937 10.793 4.72461 10.5938 4.63672C10.3945 4.54297 10.1748 4.49609 9.93457 4.49609C9.57715 4.49609 9.28418 4.56641 9.05566 4.70703C8.82715 4.84766 8.66016 5.03809 8.55469 5.27832C8.45508 5.5127 8.40527 5.78223 8.40527 6.08691C8.40527 6.38574 8.45801 6.64648 8.56348 6.86914C8.6748 7.0918 8.86523 7.29688 9.13477 7.48438C9.4043 7.66602 9.77344 7.85352 10.2422 8.04688C11.0039 8.33984 11.6719 8.65625 12.2461 8.99609C12.8203 9.33594 13.2686 9.75195 13.5908 10.2441C13.9131 10.7363 14.0742 11.3633 14.0742 12.125C14.0742 12.8809 13.8984 13.5254 13.5469 14.0586C13.1953 14.5859 12.7031 14.9902 12.0703 15.2715C11.4375 15.5469 10.7051 15.6846 9.87305 15.6846C9.33398 15.6846 8.79785 15.6143 8.26465 15.4736C7.73145 15.3271 7.24805 15.0928 6.81445 14.7705C6.38086 14.4482 6.03516 14.0205 5.77734 13.4873C5.51953 12.9482 5.39062 12.2861 5.39062 11.501H7.92188C7.92188 11.9287 7.97754 12.2861 8.08887 12.5732C8.2002 12.8545 8.34668 13.0801 8.52832 13.25C8.71582 13.4141 8.92676 13.5312 9.16113 13.6016C9.39551 13.6719 9.63281 13.707 9.87305 13.707C10.248 13.707 10.5557 13.6396 10.7959 13.5049C11.042 13.3701 11.2266 13.1855 11.3496 12.9512C11.4785 12.7109 11.543 12.4414 11.543 12.1426Z" fill="#3A3E54"/></svg>
                </span>    
                <strong>{jobViewLangLabels?.salary}:</strong>
                {(job?.salary)}
            </div>
        );
      };

      useEffect(() => {
        const fullUrl = window.location.href;
       
        if(fullUrl.includes("turbo_frontend")){
            setHomeUrl(window.location?.origin + "/" + "turbo_frontend");
        }else if(fullUrl.includes("flk_demo")){
            setHomeUrl(window.location?.origin + "/" + "flk_demo");
        }

      }, []);
      

    return (
        (similarJobList.length > 0) ? (
        <>
             <div className="similar-jobs-parent">
                <h3 className="similar-jobs-container">Find Similar Jobs</h3>
                <div className="similar-jobs-container">
                    
                    {similarJobList.map((job: any, index: number) => {
                        return (
                            <div className="similar-jobs-list" key={index}>
                                <div className="similar-jobs-list-top">
                                    <div className="similar-jobs-list-top-left">
                                        <a href={`${homeUrl}/view/${job?.id}`}><h2>{job?.title}</h2></a>
                                        <p className="job_ref_value">{job?.referenceNo}</p>
                                    </div>
                                    <div className="similar-jobs-list-top-right">
                                        {
                                            job?.logo ? (
                                                <img src={job?.logo} className="img-fluid" alt="logo" />
                                            ) : (
                                                <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M20.9228 7.44459H26.4838L26.4843 7.44471C27.9351 7.44471 29.1132 8.62398 29.1132 10.0736V13.5192C29.1132 13.9725 28.7508 14.3349 28.2975 14.3349H16.4208V13.6998C16.4208 13.3976 16.1788 13.1556 15.8766 13.1556H13.6409C13.3387 13.1556 13.0967 13.3976 13.0967 13.6998V14.3349H1.21999C0.766692 14.3349 0.404297 13.9725 0.404297 13.5192V10.044C0.404297 8.62268 1.55289 7.44459 3.00368 7.44459H8.59434V6.054C8.59434 3.90924 10.346 2.15625 12.4921 2.15625H17.0251C19.1698 2.15625 20.9228 3.90791 20.9228 6.054V7.44459ZM12.4917 5.05768C11.9475 5.05768 11.4942 5.51098 11.4942 6.05518L11.4941 7.44459L18.0222 7.44577V6.05518C18.0222 5.51098 17.5689 5.05768 17.0247 5.05768H12.4917ZM16.3895 15.846H27.1484L27.1484 15.8458C27.6017 15.8458 27.9641 16.2082 27.9641 16.6615V24.4585C27.9641 25.9093 26.786 27.0874 25.3353 27.0874H4.15179C2.73049 27.0874 1.55241 25.9388 1.55241 24.488V16.6617C1.55241 16.2084 1.9148 15.846 2.3681 15.846H13.1563C13.2472 16.631 13.9118 17.2661 14.7581 17.2661C15.6033 17.2661 16.2986 16.6617 16.3895 15.846Z" fill="#DCDEE5"/>
</svg>

                                            )
                                        }
                                    </div>
                                </div>
                                <div className="similar-jobs-list-content"> 
                                    {locationDetails(job)}
                                    {employmentType(job)}
                                    {salary(job)}
                                </div>
                            </div>
                        );
                    })}                    
                </div>
            </div>
        </>
        ) : null
    
    );
};

export default SimilarJobs;


